import React, { useState } from 'react';
import styles from "./branchorder.module.css";

// 물품명 "본체, 옵션, 옵션" → [본체, 옵션]
export const splitName = (name: string) => {
    const i = (name || "").indexOf(", ");
    return i < 0 ? [name || "", ""] : [name.slice(0, i), name.slice(i + 2)];
};

// 상태 → [라벨, 칩 클래스]
export const STATUS: { [key: string]: [string, string] } = {
    submitted: ["접수", "submitted"],
    needs_clarification: ["확인 필요", "ask"],
    response_received: ["답변 완료", "replied"],
    processing: ["주문 진행 중", "run"],
    placed: ["주문 완료", "done"],
    failed: ["실패", "fail"],
    uncertain: ["확인 필요(사람)", "fail"],
};

export const STATUS_FILTERS: [string, string[] | null][] = [
    ["전체", null],
    ["진행 중", ["submitted", "response_received", "processing"]],
    ["확인 필요", ["needs_clarification", "uncertain"]],
    ["완료", ["placed"]],
    ["실패", ["failed"]],
];

export const StatusChip: React.FC<{ status: string; small?: boolean }> = (props) => {
    const [label, cls] = STATUS[props.status] || [props.status, "submitted"];
    return (
        <span className={`${styles.st} ${styles[cls]}`} style={props.small ? { height: 20, fontSize: 11, padding: "0 7px" } : undefined}>{label}</span>
    );
};

// 상품 사진 (로드 실패·없음 → 분류명 박스)
export const Thumb: React.FC<{ image?: string; category?: string }> = (props) => {
    const [failed, setFailed] = useState(false);
    if (!props.image || failed) {
        return <span className={styles.ph} aria-hidden="true">{props.category}</span>;
    }
    return <img src={props.image} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
};

export const fmtDate = (d: any) => {
    const date = new Date(d);
    return `${date.getMonth() + 1}월 ${date.getDate()}일`;
};

export const fmtTime = (d: any) => {
    const date = new Date(d);
    return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

export const ChatIcon = () => <svg viewBox="0 0 24 24"><path d="M4 5h16v11H8l-4 4z" /></svg>;
export const SearchIcon = () => <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="M20 20l-4-4" /></svg>;
export const PlusIcon = () => <svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></svg>;
export const ChevronIcon = () => <svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></svg>;
